import React, { useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import PressableStyled from './PressableStyled';
import ColumnsIcon12 from './12pxIcons/ColumnsIcon12';
import Colors from '../constants/Colors';
import Style from '../constants/Style';

interface ColumnsButtonProps {
  onPress: () => void;
  tooltipText?: string;
  testID?: string;
}

const ColumnsButton = ({ onPress, tooltipText, testID }: ColumnsButtonProps) => {
  const [buttonHovered, setButtonHovered] = useState<boolean>(false);
  const [tooltipHovered, setTooltipHovered] = useState<boolean>(false);

  return <View style={Style.row}>
    {!!tooltipText && <View
      style={styles.container}
      onPointerEnter={() => setTooltipHovered(true)}
      onPointerLeave={() => setTooltipHovered(false)}
    >
      {(buttonHovered || tooltipHovered) && <View style={styles.tooltipBox}>
        <Text style={styles.tooltipText}>{tooltipText}</Text>
      </View>}
    </View>}
    <PressableStyled
      style={styles.button}
      children={<ColumnsIcon12 />}
      {...{ onPress, testID }}
      onHoverIn={() => setButtonHovered(true)}
      onHoverOut={() => setButtonHovered(false)}
    />
  </View>;
};

const styles = StyleSheet.create({
  container: {
    minWidth: 32,
    height: 32,
  },
  tooltipBox: {
    position: 'absolute',
    end: 4,
    bottom: 0,
    borderRadius: 5,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: '#FFF',
    width: 180,
    minHeight: 32,
  },
  tooltipText: {
    fontSize: 12,
    lineHeight: 18,
    fontFamily: 'Poppins_500Medium',
    letterSpacing: 0.15,
    color: Colors.light.hereworksBlue400,
  },
  button: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 4,
    borderColor: Colors.light.hereworksBlue100,
  },
});

export default ColumnsButton;
